"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wasmHashRegex = exports.contractIdRegex = void 0;
exports.contractIdRegex = /^C[A-Z0-9]{55}$/;
exports.wasmHashRegex = /^[a-f0-9]{64}$/;
